/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/execution/components/ResponseControl.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Execution Workspace
 *
 * DESCRIPTION:
 * Renders the appropriate response input based on the
 * checklist item's configured response type.
 *
 ******************************************************************************/

import React from "react";

export default function ResponseControl({

    item,

    value,

    disabled = false,

    onChange,

}) {

    const handleChange = (newValue) => {

        if (onChange) {

            onChange(newValue);

        }

    };

    switch (item.response_type) {

        case "PASS_FAIL":

            return (

                <div className="d-flex gap-4">

                    {["PASS", "FAIL", "NA"].map((option) => (

                        <div
                            className="form-check"
                            key={option}
                        >

                            <input
                                type="radio"
                                className="form-check-input"
                                checked={value === option}
                                disabled={disabled}
                                onChange={() =>
                                    handleChange(option)
                                }
                            />

                            <label className="form-check-label">

                                {option === "NA"
                                    ? "N/A"
                                    : option}

                            </label>

                        </div>

                    ))}

                </div>

            );

        case "YES_NO":

            return (

                <div className="d-flex gap-4">

                    {["YES", "NO"].map((option) => (

                        <div
                            className="form-check"
                            key={option}
                        >

                            <input
                                type="radio"
                                className="form-check-input"
                                checked={value === option}
                                disabled={disabled}
                                onChange={() =>
                                    handleChange(option)
                                }
                            />

                            <label className="form-check-label">

                                {option}

                            </label>

                        </div>

                    ))}

                </div>

            );

        case "NUMBER":

            return (

                <input

                    type="number"

                    className="form-control"

                    value={value || ""}

                    disabled={disabled}

                    onChange={(e) =>
                        handleChange(e.target.value)
                    }

                />

            );

        case "TEXT":

            return (

                <textarea

                    className="form-control"

                    rows={3}

                    value={value || ""}

                    disabled={disabled}

                    onChange={(e) =>
                        handleChange(e.target.value)
                    }

                />

            );

        case "DATE":

            return (

                <input

                    type="date"

                    className="form-control"

                    value={value || ""}

                    disabled={disabled}

                    onChange={(e) =>
                        handleChange(e.target.value)
                    }

                />

            );

        case "TIME":

            return (

                <input

                    type="time"

                    className="form-control"

                    value={value || ""}

                    disabled={disabled}

                    onChange={(e) =>
                        handleChange(e.target.value)
                    }

                />

            );

        case "DROPDOWN":

            return (

                <select

                    className="form-select"

                    value={value || ""}

                    disabled={disabled}

                    onChange={(e) =>
                        handleChange(e.target.value)
                    }

                >

                    <option value="">

                        Select

                    </option>

                    {(item.options || []).map((option) => (

                        <option
                            key={option.value}
                            value={option.value}
                        >

                            {option.label}

                        </option>

                    ))}

                </select>

            );

        default:

            return (

                <div className="text-muted">

                    Unsupported response type

                </div>

            );

    }

}